import { render, staticRenderFns } from "./PickupViewer.vue?vue&type=template&id=1ac4e7bd"
import script from "./PickupViewer.vue?vue&type=script&lang=js"
export * from "./PickupViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports